export var FETCH_FINANCE_ORGANIZATIONS_REQUEST = 'FETCH_FINANCE_ORGANIZATIONS_REQUEST';
export var FETCH_FINANCE_ORGANIZATIONS_SUCCESS = 'FETCH_FINANCE_ORGANIZATIONS_SUCCESS';
export var FETCH_FINANCE_ORGANIZATIONS_FAILURE = 'FETCH_FINANCE_ORGANIZATIONS_FAILURE';
export var FETCH_FINANCE_ORGANIZATION_REQUEST = 'FETCH_FINANCE_ORGANIZATION_REQUEST';
export var FETCH_FINANCE_ORGANIZATION_SUCCESS = 'FETCH_FINANCE_ORGANIZATION_SUCCESS';
export var FETCH_FINANCE_ORGANIZATION_FAILURE = 'FETCH_FINANCE_ORGANIZATION_FAILURE';